import axios from "axios";
import swal from "sweetalert";
import i18n from "../i18n";

export default {
  state: {
    selectedJourney: null,
    selectedJourneyDetails: null,
    showJourney: false,
    showJourneys: false,
    journeys: null,
    scrollHelpDismissed: false,
    journeyLoaded: false
  },
  actions: {
    loadJourneys({ commit, dispatch }) {
      axios.get("/api/journeys")
      .then((response) => {
        commit("setJourneys", response.data);
        commit("recordJourneysView");
      })
      .catch((error)=>{
        console.log(error);
      });
    },
    async promptStartJourney({ dispatch }) {
      let confirm = await swal({
        title: i18n.t("message.learner-journey-start-question"),
        text: i18n.t("message.learner-journey-info"),
        buttons: [
          i18n.t("message.not-now"),
          i18n.t("message.start-journey")
        ],
      });
      if (confirm) {
        dispatch("startSelectedJourney");
      }
    },
    async startSelectedJourney({ commit, getters, state }) {
      if (!state.selectedJourney) {
        console.error("No journey selected");
        return;
      }
      await axios.post(`/api/journeys/journey/enroll/${state.selectedJourney}`)

      state.selectedJourneyDetails.started = true;

      if (state.journeys) {
        const journey = state.journeys.find((j)=>j.id == state.selectedJourney);
        if (journey) {
          journey.started = true;
        }
      }

      const currentUser = getters.currentUser;
      currentUser.journeys.unshift(state.selectedJourney);
      commit("setUser", currentUser);

      if (window.reloadHomeContent) {
        window.reloadHomeContent();
      }
    },
    async leaveSelectedJourney({ commit, getters, state }) {
      if (!state.selectedJourney) {
        console.error("No journey selected");
        return;
      }
      await axios.delete(`/api/journeys/journey/unenroll/${state.selectedJourney}`)

      state.selectedJourneyDetails.started = false;
      if (!state.selectedJourneyDetails.assigned) {
        state.selectedJourneyDetails.added = false;
      }

      if (state.journeys) {
        const journey = state.journeys.find((j)=>j.id == state.selectedJourney);
        if (journey) {
          journey.started = false;
          if (!journey.assigned) {
            journey.added = false;
          }
        }
      }

      const currentUser = getters.currentUser;
      currentUser.journeys = currentUser.journeys.filter((j)=>j !== state.selectedJourney);
      commit("setUser", currentUser);

      if (window.reloadHomeContent) {
        window.reloadHomeContent();
      }
    }
  },
  mutations: {
    setSelectedJourney(state, journeyId) {
      state.selectedJourney = journeyId;
      if (!journeyId) {
        state.journeyLoaded = false;
      }
    },
    setSelectedJourneyDetails(state, journey) {
      state.selectedJourneyDetails = journey;
    },
    markJourneysAsViewed(state) {
      state.journeys = state.journeys.map((j) => {
        j.new = false;
        return j;
      });
    },
    setJourneyLoaded(state, loaded) {
      state.journeyLoaded = loaded;
    },
    setShowJourney(state, show) {
      state.showJourney = show;
      if (show) {
        state.showJourneys = !show;
      }
    },
    setShowJourneys(state, show) {
      state.showJourneys = show;
      if (show) {
        // Always reload data in case steps and/or Journeys have been completed
        this.dispatch('loadJourneys');
        state.showJourney = !show;
      }
    },
    setJourneys(state, journeys) {
      state.journeys = journeys;
    },
    dismissScrollHelp(state) {
      state.scrollHelpDismissed = true;
    }
  },
  getters: {
    scrollHelpVisible(state, getters) {
      return !getters.currentUser.seen_journeys && !state.scrollHelpDismissed;
    }
  }
};

